import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding:20px 0px;
`

export const LabelWrapper = styled.div`
  gap:6px;
  display: flex;
  flex-direction: column;
`

export const DetailsContent = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const InfoSection = styled.div`
  flex: 1 1 320px;
  min-width: 280px;
`;

export const CreditSection = styled.div`
  flex: 1 1 320px;
  min-width: 280px;
  background-color: ${({theme}) => theme.base.white};
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 12px 30px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CreditHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
`;

export const CreditMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CreditList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CreditRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const CreditValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: ${({theme}) => theme.palette[900]};
`;

export const CreditActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background-color: ${({theme}) => theme.palette[200]};
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({theme}) => theme.palette[300]};
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const ConfigurationLink = styled.button`
  background: none;
  border: none;
  color: ${({theme}) => theme.primary[600]};
  font-weight: 600;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    text-decoration: underline;
  }

  img {
    width: 16px;
    height: 16px;
  }
`;
